export default function capitalize(input) {
  if (typeof input === 'string' && (input?.length || 0) > 0) {
    const baseString = input.toLowerCase();
    return baseString[0].toUpperCase() + baseString.slice(1, baseString.length);
  }
  else {
    return undefined;
  }
}